import axios from 'axios'
import { getFormHeaders, getHeaders } from '../../config'

// The two vehicle-history requests that cannot go through the house helpers.
//
// `uploadPreview` sends a FILE, so it needs the multipart headers rather than JSON — and it fires
// no toast of its own, because the drawer reports the outcome beside the image it just replaced.
//
// `getQuiet` is a GET that does NOT toast on failure. The Products page polls nothing, but the
// order page re-reads itself after every action, and a second "Error getting order, retry." on
// top of the action's own refusal tells the operator to do the one thing that just failed.
export const uploadPreview = async (url, file) => {
  const form = new FormData()
  form.append('image', file)
  try {
    const response = await axios.post(url, form, { headers: getFormHeaders() })
    return { success: true, data: response.data }
  } catch (error) {
    return { success: false, error }
  }
}

export const getQuiet = async url => {
  try {
    const response = await axios.get(url, { headers: getHeaders() })
    return { success: true, data: response.data }
  } catch (error) {
    return { success: false, error }
  }
}

export const postQuiet = async (url, payload) => {
  try {
    const response = await axios.post(url, payload, { headers: getHeaders() })
    return { success: true, data: response.data }
  } catch (error) {
    return { success: false, error }
  }
}

export const patchQuiet = async (url, payload) => {
  try {
    const response = await axios.patch(url, payload, { headers: getHeaders() })
    return { success: true, data: response.data }
  } catch (error) {
    return { success: false, error }
  }
}

export const deleteQuiet = async url => {
  try {
    const response = await axios.delete(url, { headers: getHeaders() })
    return { success: true, data: response.data }
  } catch (error) {
    return { success: false, error }
  }
}
